/* MiaouLab - ajout au panier depuis le bloc d'upsell du tiroir.

   Reprend exactement le chemin de Dawn : on demande a /cart/add.js de
   renvoyer, en plus de la ligne ajoutee, le HTML des sections que le
   tiroir sait remplacer (cart-drawer et cart-icon-bubble), puis on passe
   la reponse a CartDrawer.renderContents. C'est la meme mecanique que
   product-form.js.

   Consequence : une seule requete met a jour les lignes du panier, le
   total, la pastille du header, la barre de livraison offerte et le bloc
   d'upsell lui-meme. Comme l'upsell est recalcule cote serveur a partir
   du panier reel, le produit qu'on vient d'ajouter en disparait
   automatiquement et le suivant prend sa place. Aucun etat n'est maintenu
   cote JavaScript, donc rien ne peut se desynchroniser.

   Variante : si le produit propose en compte plusieurs, un menu deroulant
   est rendu sous la carte et c'est sa valeur qui prime. Sinon on utilise
   l'unique variante posee sur le bouton. */

class MiaUpsell extends HTMLElement {
  connectedCallback() {
    this.bouton = this.querySelector('[data-mia-upsell-ajouter]');
    this.zoneErreur = this.querySelector('[data-mia-upsell-erreur]');
    this.selecteur = this.querySelector('[data-mia-upsell-variante]');

    if (!this.bouton || this.bouton.dataset.miaLie === '1') return;

    this.bouton.dataset.miaLie = '1';
    this.libelleInitial = this.bouton.textContent.trim();
    this.bouton.addEventListener('click', this.ajouter.bind(this));
  }

  varianteChoisie() {
    if (this.selecteur && this.selecteur.value) return this.selecteur.value;
    return this.bouton.dataset.varianteId;
  }

  erreur() {
    if (!this.zoneErreur) return;
    /* Message ecrit ici plutot que relaye depuis Shopify : /cart/add.js
       renvoie une partie de ses erreurs en anglais - « Cannot find
       variant » - ce qui n'a rien a faire sur une boutique francaise. La
       formulation reste volontairement neutre : elle doit rester vraie
       aussi bien pour une rupture de stock que pour une limite de
       quantite. La fiche produit, accessible depuis le nom juste au
       dessus, porte le detail. */
    this.zoneErreur.textContent = 'Ajout impossible pour le moment.';
    this.zoneErreur.hidden = false;
  }

  async ajouter(evenement) {
    evenement.preventDefault();

    const variante = this.varianteChoisie();
    if (!variante) return;

    const tiroir = document.querySelector('cart-drawer');

    this.bouton.disabled = true;
    this.bouton.setAttribute('aria-busy', 'true');
    this.bouton.textContent = this.bouton.dataset.libelleEnCours || 'Ajout…';
    if (this.zoneErreur) this.zoneErreur.hidden = true;

    /* Sans tiroir sur la page, on retombe sur la navigation classique :
       le panier est mis a jour cote serveur puis la page panier s'ouvre. */
    const sections = tiroir ? tiroir.getSectionsToRender().map((s) => s.id) : [];

    try {
      const reponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({
          items: [{ id: Number(variante), quantity: 1 }],
          sections: sections,
          sections_url: window.location.pathname,
        }),
      });

      const donnees = await reponse.json();

      /* /cart/add.js renvoie un objet portant "status" quand l'ajout a
         echoue : rupture de stock, limite de quantite, variante absente. */
      if (donnees.status) {
        this.erreur();
        return;
      }

      if (tiroir && typeof tiroir.renderContents === 'function' && donnees.sections) {
        tiroir.renderContents(donnees);
      } else {
        window.location.href = `${window.Shopify.routes.root}cart`;
        return;
      }

      /* Prevenir les autres composants Dawn, comme le fait product-form.js. */
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'mia-upsell-panier',
          productVariantId: variante,
          cartData: donnees,
        });
      }
    } catch (e) {
      this.erreur();
    } finally {
      /* renderContents remplace ce noeud : ce retablissement ne sert que
         dans les cas d'echec, ou l'element est toujours en place. */
      if (this.isConnected && this.bouton) {
        this.bouton.disabled = false;
        this.bouton.removeAttribute('aria-busy');
        this.bouton.textContent = this.libelleInitial;
      }
    }
  }
}

if (!customElements.get('mia-upsell')) {
  customElements.define('mia-upsell', MiaUpsell);
}
